<script lang="typescript">
    import Subtitle2 from "shared/typography/subtitle2.svelte";
    import Body2 from "shared/typography/body2.svelte";
    import Button from "shared/button.svelte";
    import { ModalSystem } from "shared/systems";

    export let title = "Title";
    export let description = "description body text bla bla bla bla";
    export let okText = "ok";
    export let cancelText = "cancel";

    const onResult = (result?: boolean) => {
        ModalSystem.setResult(result);
        ModalSystem.hide();
    };
</script>

<div class="confirmation-dialog">
    <div class="mb-16">
        <Subtitle2 text={title} />
    </div>
    <Body2 text={description} />
    <div class="buttons">
        <Button text={cancelText} on:click={() => onResult(undefined)} />
        <Button text={okText} on:click={() => onResult(true)} />
    </div>
</div>

<style>
    .confirmation-dialog {
        padding: 24px;
        width: 100%;
        height: 100%;
    }
    .mb-16 {
        margin-bottom: 16px;
    }
    .buttons {
        height: 36px;
        display: flex;
        margin-top: 16px;
        justify-content: flex-end;
        align-items: center;
    }
</style>
